module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooseschool chooseschool2"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "search-box",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_c('span', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "placeholder": "请输入学校名称"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.message != '') ? _c('span', {
    staticClass: "clearbtn",
    on: {
      "click": _vm.clearInput
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.searchSchool()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), (!_vm.iSearch && _vm.nearSchoolList.length > 0) ? _c('div', {
    staticClass: "search-result search-result2"
  }, [_c('div', {
    staticClass: "c-gray"
  }, [_vm._v("附近学校")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.nearSchoolList), function(item, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item.schoolName)
      },
      on: {
        "click": function($event) {
          return _vm.saveInfo(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.schoolName))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.iSearch && _vm.schoolList.length > 0) ? _c('div', {
    staticClass: "search-result search-result2"
  }, [_c('div', {
    staticClass: "c-gray"
  }, [_vm._v("搜索结果")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.schoolList), function(item, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item.schoolName)
      },
      on: {
        "click": function($event) {
          return _vm.saveInfo(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.schoolName))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isjdlw) ? _c('div', {
    staticClass: "jdlw-ready"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-00.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("亲爱的同学，你的学校当前尚未开通，快搜索别的学校看看吧~")])]) : _vm._e()]), _vm._v(" "), (_vm.showBottomTips) ? _c('div', {
    staticClass: "bottomTips"
  }, [_c('p', [_vm._v("上海鎏帑网络科技有限公司   沪ICP备18024716号-1")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v(" 联系电话：021-60761299")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402004817"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.2rem",
      "height": "0.2rem",
      "margin-top": "0.08rem",
      "float": "left"
    },
    attrs: {
      "src": require("../assets/images/record-icon.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393"
    }
  }, [_vm._v("沪公网安备 31010402004817号")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5db4a349","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/ChooseSchool.vue
// module id = 442
// module chunks = 7